import type { IconComponent } from "@overmap-ai/blocks"
import { IssuePriorityType, IssueStatusType } from "@overmap-ai/common"
import { amber, blue, gray, green, indigo, orange, red } from "@radix-ui/colors"
import {
	ChevronDown,
	ChevronsDown,
	ChevronsUp,
	ChevronUp,
	Circle,
	CircleCheck,
	CircleDashed,
	CircleMinus,
	CircleX,
	Minus,
} from "lucide-react"

import { IssueTimelineItemType } from "../enums/issues"
import { modelIconMapping } from "./icons"

export const issuePriorityTypeData: Record<IssuePriorityType, { icon: IconComponent; label: string; color: string }> = {
	[IssuePriorityType.LOWEST]: { icon: ChevronsDown, label: "Lowest", color: indigo.indigo9 },
	[IssuePriorityType.LOW]: { icon: ChevronDown, label: "Low", color: blue.blue9 },
	[IssuePriorityType.MEDIUM]: { icon: Minus, label: "Medium", color: amber.amber9 },
	[IssuePriorityType.HIGH]: { icon: ChevronUp, label: "High", color: orange.orange9 },
	[IssuePriorityType.HIGHEST]: { icon: ChevronsUp, label: "Highest", color: red.red9 },
}

export const issueStatusTypeData: Record<IssueStatusType, { icon: IconComponent; label: string; color: string }> = {
	[IssueStatusType.BACKLOG]: { icon: CircleDashed, label: "Backlog", color: gray.gray9 },
	[IssueStatusType.PLANNED]: { icon: Circle, label: "Planned", color: indigo.indigo9 },
	[IssueStatusType.IN_PROGRESS]: { icon: CircleMinus, label: "In progress", color: amber.amber9 },
	[IssueStatusType.COMPLETED]: { icon: CircleCheck, label: "Completed", color: green.green9 },
	[IssueStatusType.CANCELLED]: { icon: CircleX, label: "Cancelled", color: red.red9 },
}

export const issueTimelineItemTypeData: Record<IssueTimelineItemType, { icon: IconComponent; label: string }> = {
	[IssueTimelineItemType.CREATED]: {
		icon: modelIconMapping.issue,
		label: "Created",
	},
	[IssueTimelineItemType.ISSUE_UPDATE]: {
		icon: modelIconMapping.edit,
		label: "Updates",
	},
	[IssueTimelineItemType.ISSUE_COMMENT]: {
		icon: modelIconMapping.comment,
		label: "Comments",
	},
	[IssueTimelineItemType.ISSUE_ATTACHMENT]: {
		icon: modelIconMapping.attachment,
		label: "Attachments",
	},
	[IssueTimelineItemType.ISSUE_ASSOCIATION]: {
		icon: modelIconMapping.assetType,
		label: "Assets",
	},
	[IssueTimelineItemType.FIELD_VALUES]: {
		icon: modelIconMapping.edit,
		label: "Field values",
	},
	[IssueTimelineItemType.IDENTIFIER_VALUE]: {
		icon: modelIconMapping.identifier,
		label: "Identifiers",
	},
	[IssueTimelineItemType.FORM_SUBMISSION]: {
		icon: modelIconMapping.form,
		label: "Forms",
	},
}
